import { appointmentService } from '../../helpers/services/locationAppointment.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const APPOINTMENT_MODULE = 'appointment'; 

// define action 
export const GET_ALL_APPOINTMENTS = 'getAllAppointments';
export const GET_APPOINTMENT = 'getAppointment';
export const UPDATE_APPOINTMENT = 'updateAppointment';
export const CREATE_APPOINTMENT = 'createAppintmenr';
export const UPDATE_APPOINTMENT_STATUS = 'updateAppointmentStatus';
export const CANCEL_APPOINTMENT = 'cancelAppointment';
export const REJECT_APPOINTMENT = 'rejectAppointment';

// define mutation
const SUCCESS = "commonSuccess";
const PUBLIC_SUCCESS = "publicSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_APPOINTMENTS_REQUEST = "getAllAppointments";
const GET_APPOINTMENT_REQUEST = "getAppointment";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_APPOINTMENTS]({ commit }, { filter }) {
        appointmentService
            .getAllAppointments(filter)
            .then(
                (result) => {
                    commit(GET_ALL_APPOINTMENTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_APPOINTMENT]({ commit }, { id }) {
        appointmentService
            .getAppointment(id)
            .then(
                (result) => {
                    commit(GET_APPOINTMENT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_APPOINTMENT]({ commit }, { data, isPublic }) {
        commit(REQUEST)
        appointmentService
            .updateAppointment(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.appointment')]);
                    sharedHelper.alertSuccessMessage(message)
                    if(isPublic != true) {
                        commit(SUCCESS)
                    }
                    else {
                        commit(PUBLIC_SUCCESS)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_APPOINTMENT]({ commit }, { data, isPublic }) {
        commit(REQUEST)
        appointmentService
            .createAppointment(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.appointment')]);
                    sharedHelper.alertSuccessMessage(message)

                    if(isPublic != true) {
                        commit(SUCCESS)
                    }
                    else {
                        commit(PUBLIC_SUCCESS)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_APPOINTMENT_STATUS]({ dispatch }, { filter, data }) {
        appointmentService
            .updateAppointmentStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_APPOINTMENTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    [CANCEL_APPOINTMENT]({ dispatch }, { filter, data }) {
        appointmentService
            .cancelAppointment(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.cancelXSuccess",[i18n.t('module.appointment')]);
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_APPOINTMENTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    [REJECT_APPOINTMENT]({ dispatch }, { filter, data }) {
        appointmentService
            .cancelAppointment(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.rejectXSuccess",[i18n.t('module.appointment')]);
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_APPOINTMENTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Appointment-listing" });
    },
    [PUBLIC_SUCCESS](state) {
        state.status = {};
        //TODO think the flow 
        // router.push({ name: "Appointment-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_APPOINTMENTS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                email: o.customer_email,
                phoneCode: o.customer_phone_code,
                phoneISO: o.customer_phone_iso,
                phone: o.customer_phone,
                startTime: o.appointment_start_time_slot,
                endTime: o.appointment_end_time_slot,
                status: o.status,
                location: o.location,
                customer: o.customer,
                details: o.details,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time),
                locationID: o.location != null ? {
                    value: o.location.uuid,
                    text: o.location.name
                } : '',
            }
        })
    },
    [GET_APPOINTMENT_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
                email: o.customer_email,
                phoneCode: o.customer_phone_code,
                phoneISO: o.customer_phone_iso,
                phone: o.customer_phone,
                startTime: o.appointment_start_time_slot,
                endTime: o.appointment_end_time_slot,
                status: o.status,
                location: o.location,
                customer: o.customer,
                details: o.details,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time),
                locationID: o.location != null ? {
                    value: o.location.uuid,
                    text: o.location.name
                } : '',
        }

    }
}


